import { Component } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { DxAspNetDataXsrfAwareService } from '@tools';
import { Config } from '@config';
import { UrlEnhancerService } from '@url';
import { AuthHttp } from '@http';
import { confirm } from 'devextreme/ui/dialog';
import { __i18n } from '@localisation';
import { lastValueFrom } from 'rxjs';
import { States, StateService } from '@state';

@Component({
    selector: 'task-list',
    templateUrl: './task-list.template.html',
    standalone: false
})
export class TaskListComponent {
    constructor(
        private dxAspNetXsrfAwareService: DxAspNetDataXsrfAwareService,
        private config: Config,
        private urlEnhancer: UrlEnhancerService,
        public stateService: StateService,
        private http: AuthHttp
    ){
        const themeConfig = this.stateService.value(States.themeConfig).get();
        this.enableUITwo = themeConfig.enableUITwo || false;
    }

    public enableUITwo = false;

    public ngOnInit(){
        this.activeTasksSource = new DataSource({
            paginate: true,
            store: this.dxAspNetXsrfAwareService.createStore({
                loadUrl: this.urlEnhancer.replaceParams(this.config.services.task.active),
                loadMethod: 'POST',
                key: 'TaskId'
            })
        });

        this.taskHistorySource = new DataSource({
            paginate: true,
            store: this.dxAspNetXsrfAwareService.createStore({
                loadUrl: this.urlEnhancer.replaceParams(this.config.services.task.history),
                loadMethod: 'POST',
                key: 'TaskId'
            })
        })
    }

    public remoteOperations = {
        paging: true, filtering: true, sorting: true, grouping: true, summary: true, groupPaging: true
    };

    public activeTasksSource: DataSource;

    public taskHistorySource: DataSource;

    public refresh(){
        this.activeTasksSource.reload();
        this.taskHistorySource.reload();
    }


    public async cancelTask(taskId : string){
        if(
            await confirm(
                __i18n('Really want to cancel this task?', 'task.list.active-tasks.cancel.confirm.message'),
                __i18n('Please confirm', 'task.list.active-tasks.cancel.confirm.title'),
            )
        ){
            await lastValueFrom(this.http.putJSON(this.urlEnhancer.replaceParams(this.config.services.task.cancelTask, {
                taskid : taskId
            }), {}));
            this.refresh()
        }
    }

}